import { render, staticRenderFns } from "./hotel.vue?vue&type=template&id=41304d9c&"
import script from "./hotel.vue?vue&type=script&lang=js&"
export * from "./hotel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports